// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CashoutError-CashoutError-wrapper-24hhxXpY","message":"CashoutError-CashoutError-message-2bWHKM7c"};